import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchRules, deleteRule, fetchRule } from 'redux/rules/RulesActions';
import RulesOperations from './RulesOperations';

const mapStateToProps = ({ rules }) => ({
  rules: rules.rules,
  totalEntries: rules.pageState.totalEntries,
  fetchingRules: rules.fetchingRules
});

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ fetchRules, deleteRule, fetchRule }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RulesOperations);



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/rulesOperations/RulesOperationsConnector.js